import { render } from "./TradeTransectionHistory.vue?vue&type=template&id=4627a3bd"
import script from "./TradeTransectionHistory.vue?vue&type=script&lang=js"
export * from "./TradeTransectionHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__